import {
  NETWORK_BACK_TOAST_CONFIG,
  NETWORK_ERROR_TOAST_CONFIG,
} from "lib/constants";
import { useEffect, useState } from "react";
import { toast } from "sonner";

const useNetworkStatus = (): boolean => {
  const [isOnline, setIsOnline] = useState<boolean>(navigator.onLine);

  const updateStatus = () => {
    setIsOnline(navigator.onLine);
  };

  useEffect(() => {
    window.addEventListener("online", updateStatus);
    window.addEventListener("offline", updateStatus);

    return () => {
      window.removeEventListener("online", updateStatus);
      window.removeEventListener("offline", updateStatus);
    };
  }, []);

  useEffect(() => {
    if (!isOnline) {
      toast.error(
        "You're offline, Please check your connection",
        NETWORK_ERROR_TOAST_CONFIG
      );
    } else {
      toast.dismiss("network-error");
      toast.success("You're back online", NETWORK_BACK_TOAST_CONFIG);
    }
  }, [isOnline]);

  return isOnline;
};

export default useNetworkStatus;
